import { Component, inject } from '@angular/core';
import { EnvironmentService } from '@eforall/common';
import { AppService, FuncService } from '../../services';


@Component({
	selector: 'home-page',
	imports: [
	],
	templateUrl: './home.page.html'
})
export class HomePage {

	public env = inject(EnvironmentService);
	private func = inject(FuncService);
	public app = inject(AppService);

	async getAppData() {
		await this.func.getData();
	}

}
